import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./component/Navbar";
import "./App.css";
import Login from "./component/Login";
import MyFamilyTree from "./component/MyFamilyTree";
import { PrivateRoutes } from "./component/PrivateRoutes";
import Registration from "./component/Registration";
import SignUp from "./component/signUp/SignUp";
import AddMembers from "./component/addMembers2/AddMembers";
import Tamplate from "./component/Tamplate/Tamplate";

const App = () => {
  return (
    <div className="App">
      <Navbar />
      <div style={{ height: "70px" }}> </div>
      <Routes>
        <Route path="/log-in" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/sign-up" element={<SignUp />} />
        {/* <Route style={{ width: "100vw", }} path="/family-tree" element={<FamilyTree />} /> */}
        <Route
          path="/"
          element={
            <PrivateRoutes>
              <MyFamilyTree />
            </PrivateRoutes>
          }
        />
        <Route
          path="/add-members"
          element={
            <PrivateRoutes>
              <AddMembers />
            </PrivateRoutes>
          }
        />
        {/* <Route path="/tem" element={<Tamplate />} /> */}
      </Routes>
    </div>
  );
};

export default App;
